import { lazy } from "react";
import type { RouteConfig } from "../types";
import { ComponentSuspense } from "@/components/ui/suspense-wrapper";

// Settings pages
const UsersSettings = lazy(() => import("@/pages/app/admin/settings/users"));
// Roles settings pages
const RolesSettings = lazy(
  () => import("@/pages/app/admin/settings/roles")
);
// Audit logs settings page
const AuditLogsSettings = lazy(
  () => import("@/pages/app/admin/settings/audit-logs")
);

export const adminSettingsRoutes: RouteConfig[] = [
  // Settings routes
  {
    path: "admin/settings/users",
    element: (
      <ComponentSuspense>
        <UsersSettings />
      </ComponentSuspense>
    ),
    meta: {
      title: "Users Settings | UzaForm",
      description: "Manage users, roles, and user-role assignments",
    },
  },
  {
    path: "admin/settings/roles",
    element: (
      <ComponentSuspense>
        <RolesSettings />
      </ComponentSuspense>
    ),
    meta: {
      title: "Roles Settings | UzaForm",
      description: "Manage roles and permissions",
    },
  },
  {
    path: "admin/settings/audit-logs",
    element: (
      <ComponentSuspense>
        <AuditLogsSettings />
      </ComponentSuspense>
    ),
    meta: {
      title: "Audit Logs | UzaForm",
      description: "View and manage system audit logs",
    },
  }
];
